import { useStyle } from '@/classify';
import { useSearchField } from '@/hooks/SearchBar';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { X as ClearIcon, Search as SearchIcon } from 'react-feather';
import Icon from '../Icon';
import TextInput from '../TextInput';
import Trigger from '../Trigger';
import defaultClasses from './searchField.module.css';
const clearIcon = (
  <Icon
    src={ClearIcon}
    size={24}
  />
);
const searchIcon = (
  <Icon
    src={SearchIcon}
    size={24}
  />
);

// const searchIcon = (
//   <Icon
//     src={SearchIcon}
//     size={24}
//     onClick={handleSearchClick}
//     style={{ cursor: 'pointer' }}
//   />
// );
const SearchField = props => {
  const { isSearchOpen, onChange, onFocus, classes: propClasses, onSubmit } = props;
  const classes = useStyle(defaultClasses, propClasses);
  const { inputRef, resetForm, value } = useSearchField({
    isSearchOpen,
  });
  const handleSearchClick = () => {
    const searchQuery = value || inputRef.current?.value;
    if (searchQuery) {
      // 触发父组件的handleSubmit
      onSubmit({ search_query: searchQuery });
    }
  };
  const searchButton = <Trigger action={handleSearchClick}>{searchIcon}</Trigger>;
  const resetButton = (
    <Trigger action={resetForm}>
      <Image
        src={`/searchClear.svg`}
        width={20}
        height={20}
        alt='close'
      />
    </Trigger>
  );
  return (
    <div className={cn('relative h-[50px] ', classes.root)}>
      <TextInput
        expandClasses={{
          inputClass: 'border-[#4C4C4C] text-[16px] lg_text-[18px]',
        }}
        id='search_query'
        after={resetButton}
        // before={searchIcon}
        field='search_query'
        onFocus={onFocus}
        onValueChange={onChange}
        onChange={onChange}
        ref={inputRef}
        placeholder='search'
      />
      <Icon
        src={SearchIcon}
        size={24}
        onClick={handleSearchClick}
        className='absolute right-0 top-[12px] h-[22px] w-[22px] cursor-pointer lg_top-[10px] lg_h-[30px] lg_w-[30px]'
      />
      {/* <Image
        src={`/icons/close.svg`}
        width={30}
        height={30}
        alt='close'
        onClick={() => resetForm()}
        className='absolute right-0 top-[12px] h-[22px] w-[22px] cursor-pointer lg_top-[8px] lg_h-[30px] lg_w-[30px]'
      /> */}
    </div>
  );
};

export default SearchField;
